var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4751 9.72175C25.6645 8.34991 24.3355 8.34991 23.5239 9.72175L6.76336 38.0523C5.9518 39.4251 6.61581 40.5474 8.23894 40.5474H41.7611C43.3842 40.5474 44.0482 39.4251 43.2366 38.0523L26.4751 9.72175Z",
    fill: "#C4D3CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9992 4.91992C24.0617 4.91992 23.141 5.60248 22.4081 6.84088L3.64861 38.5506C2.91575 39.789 2.77016 40.9084 3.23939 41.7014C3.70862 42.4934 4.77399 42.9302 6.23973 42.9302H43.7597C45.2254 42.9302 46.2908 42.4934 46.76 41.7014C47.2292 40.9084 47.0837 39.789 46.3508 38.5506L27.5903 6.84088C26.8584 5.60248 25.9377 4.91992 25.0002 4.91992H24.9992ZM43.76 44.8502H6.24007C4.04146 44.8502 2.37111 44.0736 1.53593 42.6614C0.700755 41.2493 0.845361 39.4483 1.94417 37.5907L20.7046 5.88096C21.8044 4.02336 23.3302 3 24.9995 3H25.0005C26.6709 3 28.1956 4.02336 29.2945 5.88096L48.0549 37.5907C49.1547 39.4483 49.2993 41.2493 48.4641 42.6614C47.629 44.0736 45.9586 44.8502 43.76 44.8502Z",
    fill: "#46484B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9994 15.5703C25.7146 15.5703 26.2979 16.1406 26.2979 16.8375V29.5134C26.2979 30.2103 25.7146 30.7806 24.9994 30.7806C24.2853 30.7806 23.7009 30.2103 23.7009 29.5134V16.8375C23.7009 16.1406 24.2853 15.5703 24.9994 15.5703Z",
    fill: "#46484B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8213 35.1918C22.8213 36.3986 23.7647 37.3192 25.0002 37.3192C26.2348 37.3192 27.1792 36.3986 27.1792 35.1918C27.1792 33.988 26.2348 33.0664 25.0002 33.0664C23.7647 33.0664 22.8213 33.988 22.8213 35.1918Z",
    fill: "#46484B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8378_6259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 33,
    width: 6,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8213 35.1918C22.8213 36.3986 23.7647 37.3192 25.0002 37.3192C26.2348 37.3192 27.1792 36.3986 27.1792 35.1918C27.1792 33.988 26.2348 33.0664 25.0002 33.0664C23.7647 33.0664 22.8213 33.988 22.8213 35.1918Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8378_6259)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningGrey);
export default __webpack_public_path__ + "static/media/warning-grey.05e3a8b0826b380b43e03cccd903fa1a.svg";
export { ForwardRef as ReactComponent };